import axios from 'axios'

const state = {
    patient: {
        first_name: "",
        last_name: "",
        second_name: "",
        phone_number: "+998",
        phone_number2: "+998",
        region: {},
        district: {},
        mfy: {},
        street: "",
        flat: "",
    },
    patients: {},
    patient_names: [],
    patients_loading: false,
    patients_errors: {}
}

const getters = {
    patient: state => state.patient,
    patients: state => state.patients,
    patients_loading: state => state.patients_loading,
    patients_errors: state => state.patients_errors,
    patient_names: state => state.patient_names,

}

const mutations = {
    setPatients(state, patients) {
        state.patients = patients
    },
    setPatient(state, patient) {
        state.patient = patient
    },
    setPatientsLoading(state, loading) {
        state.patients_loading = loading
    },
    setPatientsErrors(state, errors) {
        state.patients_errors = errors
    },
    setPatientNames(state, patient_names) {
        state.patient_names = patient_names
    },

}

const actions = {
    async getPatient({commit}, id) {
        commit('setPatientsLoading', true)
        commit('setPatientsErrors', {})
        try {
            if (id) {

                let response = await axios.get(`/api/cashier/patients/${id}/show`)
                commit('setPatients', response.data)
            }

            commit('setPatientsLoading', false)

            return false

        } catch (error) {
            commit('setPatientsLoading', false)
            commit('setPatients', {data: []})

            commit('setPatientsErrors', error.response.data.errors)
            return false
        }

    },
    async getPatientInfo({commit}, id) {
        commit('setPatientsLoading', true)
        commit('setPatientsErrors', {})
        try {
            if (id) {

                let response = await axios.get(`/api/cashier/patients/${id}/info`)
                commit('setPatients', response.data)
            }

            commit('setPatientsLoading', false)
            return false

        } catch (error) {
            commit('setPatientsLoading', false)
            commit('setPatientsErrors', error.response.data.errors)
            return false
        }
    },
    async getTodaysOrders({commit}, params) {
        commit('setPatientsLoading', true)
        commit('setPatientsErrors', {})
        try {

            let response = await axios.get(`/api/cashier/orders/todays`, {params})
            commit('setPatients', response.data)
            commit('setPatientsLoading', false)
            return true

        } catch (error) {
            commit('setPatientsLoading', false)
            commit('setPatientsErrors', error.response.data.errors)
            return false
        }
    },
    async getOrders({commit}, params) {
        commit('setPatientsLoading', true)
        commit('setPatientsErrors', {})
        try {

            let response = await axios.get(`/api/cashier/orders`, {params})
            commit('setPatients', response.data)
            commit('setPatientsLoading', false)
            return true

        } catch (error) {
            commit('setPatientsLoading', false)
            commit('setPatientsErrors', error.response.data.errors)
            return false
        }
    },

    async registerData({commit}, params) {
        commit('setPatientsLoading', true)
        commit('setPatientsErrors', {})
        try {
            await axios.get(`/api/cashier/patients/store/data`, {params})
            return true

        } catch (error) {
            commit('setPatientsLoading', false)
            commit('setPatientsErrors', error.response.data.errors)
            return false
        }
    },
    async getPatientNames({commit}, params) {
        let response = await axios.get(`/api/cashier/patients/store/phone_number`, {params})
        if (response.data.ok) {
            commit('setPatientNames', response.data.data)
        }

        return true
    },
}

export default {
    state,
    getters,
    mutations,
    actions
}